export default __webpack_public_path__ + "static/media/person-outline-1.83ef07f9.svg";